export default "__VITE_ASSET__DoqPi05f__"